module.exports = __webpack_public_path__ + "img/banner-block-shadow.0edcdf23.svg";